import jobSeekerProofFiles from './models/JobSeekerProofFiles';

export default { jobSeekerProofFiles };
